








import { Component, Prop, Vue } from 'vue-property-decorator'

  @Component
    export default class VGoogleMaps extends Vue {

        @Prop(Number) lat!: number
        @Prop(Number) lng!: number

        get markers() {
            return [{
                position: {
                    lat: this.lat,
                    lng: this.lng
                }
            }]
        }
    }

